<template>
  <div class="main-box" :class="{ isMobile: isMobile }">
    <full-page v-if="!isMobile" ref="fullpage" :options="options" id="fullpage">
      <div class="section">
        <carousel></carousel>
        <static-control></static-control>
        <div
          :class="{ paradigm_next_page: true, index1: nowIndex == 0 }"
          @click="toNext"
        >
          <i class="iconfont iconjiantou"></i>
        </div>
      </div>
      <div id="section1" class="section paradigm_page_bg animate-box">
        <div class="text-box b-box">
          <interview-type></interview-type>
          <div
            :class="{ paradigm_next_page: true, index1: nowIndex == 0 }"
            @click="toNext"
          >
            <i class="iconfont iconjiantou"></i>
          </div>
        </div>
      </div>
      <div id="section2" class="section paradigm_page_bg animate-box">
        <div class="text-box w-box">
          <characteristic></characteristic>
          <div
            :class="{ paradigm_next_page: true, index1: nowIndex == 0 }"
            @click="toNext"
          >
            <i class="iconfont iconjiantou"></i>
          </div>
        </div>
      </div>
      <div
        id="section3"
        class="section fp-auto-height animate-box paradigm_page_bg"
      >
        <div class="text-box b-box">
          <leader-box></leader-box>
          <div
            :class="{ paradigm_next_page: true, index1: nowIndex == 0 }"
            @click="toNext"
          >
            <i class="iconfont iconjiantou"></i>
          </div>
        </div>
      </div>
      <div class="section fp-auto-height animate-box paradigm_page_bg">
        <div class="text-box w-box">
          <company></company>
        </div>
      </div>
    </full-page>
    <div class="mobile-box" v-if="isMobile">
      <div class="section">
        <carousel></carousel>
        <static-control></static-control>
      </div>
      <div class="section paradigm_page_bg">
        <div class="text-box b-box">
          <interview-type></interview-type>
        </div>
      </div>
      <div class="section paradigm_page_bg">
        <div class="text-box w-box">
          <characteristic></characteristic>
        </div>
      </div>
      <div class="section paradigm_page_bg">
        <div class="text-box b-box">
          <leader-box></leader-box>
        </div>
      </div>
      <div class="section paradigm_page_bg">
        <div class="text-box w-box">
          <company></company>
        </div>
      </div>
    </div>
    <footbox></footbox>
    <testControl
      :dialogVisible="dialogVisible"
      :demoDetail="demoDetail"
      :dialogWidth="isMobile ? '96%' : '500px'"
      @onCancel="onCancel"
    ></testControl>
  </div>
</template>

<script>
// https://github.com/alvarotrigo/fullPage.js
import { LOGIN_API } from "@/api.js";
import carousel from '@/components/product/interview/carousel'
import staticControl from '@/components/product/interview/static'
import interviewType from '@/components/product/interview/type'
import characteristic from '@/components/product/interview/characteristic'
import leaderBox from '@/components/product/interview/leader'
import footbox from '@/components/product/interview/footer'
import testControl from '@/components/product/interview/test'
import company from '@/components/product/interview/company'
export default {
  components: {
    carousel,
    staticControl,
    interviewType,
    characteristic,
    leaderBox,
    footbox,
    company,
    testControl,
  },
  data() {
    return {
      dialogVisible: false,
      isMobile: false,

      demoDetail: {
        link1: '',
        link2: '',
        tu1: '',
        tu2: '',
      },
      options: {
        menu: '#menu',
        verticalCentered: true,
        responsiveHeight: window.innerHeight - 60,
        sectionsColor: [
          '#f6f7fd',
          '#f6f7fd',
          '#ffffff',
          '#f6f7fd',
          '#ffffff',
          '#ffffff',
        ],
        afterLoad: this.afterLoad,
      },
      nowIndex: 1,
    }
  },
  created() {
    this.isMobile = this.$store.state.app.device
    this.$bus.on('interviewTest', this.showDialog)
    console.log(this.options)
  },
  mounted() {
    this.toPage()
    this.$bus.$off('fullpageTop')
    this.$bus.on('fullpageTop', this.fullpageTop)
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val != oldVal) {
          this.toPage()
        }
      },
      // 深度观察监听
      deep: true,
    },
    '$store.state.app.nowPage'(now) {
      const fullpage = this.$refs.fullpage
      fullpage.api.moveTo(1)
    },
  },
  methods: {
    fullpageTop() {
      const fullpage = this.$refs.fullpage
      fullpage.api.setAutoScrolling(true)
      fullpage.api.moveTo(1)
    },
    getQRcode(guid, rc) {
      let post = {
        guid: guid,
        domain: 'enjoy',
        role: 0,
        rc: rc,
      }

      this.$axios
        .post(`${LOGIN_API}/interview/api/createQrApplet`, post)
        .then((res) => {
          this.demoDetail.tu1 = res.data.result
          post.role = 1
          this.$axios
            .post(
              `${LOGIN_API}/interview/api/createQrApplet`,
              post
            )
            .then((res) => {
              this.demoDetail.tu2 = res.data.result
              this.$cookies.set(
                'interviewTest',
                JSON.stringify(this.demoDetail),
                3 * 24 * 60 * 60
              )
            })
        })
    },
    showDialog() {
      var hasModel = this.$cookies.get('interviewTest')
      if (!hasModel) {
        this.$axios
          .get(`${LOGIN_API}/customer/api/interviewLink`)
          .then((res) => {
            if (res.data.errno == 0) {
              this.demoDetail.link1 = res.data.result.candUrl
              this.demoDetail.link2 = res.data.result.interviewUrl

              this.getQRcode(res.data.result.guid, res.data.result.rc)
              this.dialogVisible = true
            } else {
              this.$message.error(res.data.errmsg)
            }
          })
      } else {
        this.demoDetail = hasModel
        this.dialogVisible = true
      }
    },
    onCancel() {
      this.dialogVisible = false
    },
    toNext() {
      const fullpage = this.$refs.fullpage
      fullpage.api.moveSectionDown()
    },
    toPage() {
      let toPage = this.$route.query.to
      if (toPage) {
        toPage = toPage.replace('section', '')
        const fullpage = this.$refs.fullpage
        if (toPage && fullpage && fullpage.api) {
          fullpage.api.moveTo(parseInt(toPage))
        }
      } else {
        const fullpage = this.$refs.fullpage
        if (fullpage && fullpage.api) {
          fullpage.api.moveTo(1)
        }
      }
      this.$route.query.to = ''
    },
    afterLoad(anchorLink, index) {
      let that = this
      this.nowIndex = index.index
      const fullpage = this.$refs.fullpage
      if (index.index == 0) {
        this.$store.dispatch('setRightBar', false)
      } else {
        this.$store.dispatch('setRightBar', true)
      }
      if (fullpage && fullpage.api) {
        if (index.isLast) {
          fullpage.api.setAutoScrolling(false)
          fullpage.api.setFitToSection(false)
          let start = $(document).scrollTop()
          $(document).scroll(function () {
            // 获得页面实时滚动的位置
            let end = $(document).scrollTop()
            // 如滚动的位置小于0，则代表页面在倒数第二屏向上滚，这个时候再改变页面的滚动方式
            if (end - start < 0) {
              if (
                that.$route.path == '/home' ||
                that.$route.path == '/product/interview'
              ) {
                fullpage.api.setAutoScrolling(true)
                setTimeout(()=>{
                  fullpage.api.moveTo(4)
                },100)
              }
            }
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.home-box {
  padding-top: 15px;
  width: 1200px;
  margin: 0px auto;
}
.main-box {
  width: 100%;
  overflow-x: hidden;
}
.main-box.isMobile {
  min-width: initial;
}
.paradigm_next_page {
  border: 3px solid rgba($color: #01c1bc, $alpha: 0.4);
  color: rgba($color: #01c1bc, $alpha: 0.4);
  border-radius: 50%;
  width: 44px;
  height: 44px;
  cursor: pointer;
  position: absolute;
  z-index: 20;
  padding: 5px;
  top: 90%;
  margin-top: -98px;
  left: 50%;
  margin-left: -24px;
  animation: paradigm_next_page_animate 2s linear;
  animation-iteration-count: infinite;
  .iconjiantou {
    font-size: 30px;
  }
}
.index1 {
  top: 87% !important;
}
.b-box {
  background: #f7f8fd url('/static/images/bbg.png') repeat-x;
}
.w-box {
  background: #fff url('/static/images/wbg.png') repeat-x;
}
.text-box {
  height: 100%;
  width: 100%;
  position: relative;
}
#fullpage .section {
  overflow: hidden;
}
#fullpage .section.fp-auto-height {
  overflow: inherit;
}
</style>

<style lang="scss">
@media screen and (max-width: 600px) {
  .mobile-box {
    .banner {
      height: 560px !important;
    }
  }
  .layour {
    .inner {
      width: 350px !important;
      height: 450px !important;
      .box1 {
        padding: 90px 0px 30px !important;
      }
      .text {
        padding: 30px 30px 0px 30px;
        .text1 {
          font-size: 28px;
        }
      }
      .bottom-btns {
        padding: 20px 0 0 0;
      }
    }
  }
  .banner-2 {
    .inner {
      width: 350px !important;
      height: 440px !important;
      background-size: cover !important;
      margin-top: 40px !important;
      .text1 {
        margin-top: -40px;
        font-size: 22px !important;
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .layour {
    .inner {
      width: 620px !important;
      height: 620px !important;
      .box1 {
        padding: 120px 0px 30px !important;
        img {
          height: 80px;
        }
      }
      .text {
        padding: 30px 30px 0px 30px;
        .text1 {
          font-size: 40px;
        }
        .text2 {
          font-size: 24px;
        }
      }
    }
  }
  .banner-2 {
    .inner {
      width: 620px !important;
      height: 650px !important;
      background-size: cover !important;
      .text1 {
        margin-top: 20px;
        font-size: 32px !important;
      }
      .text2 {
        font-size: 24px !important;
      }
      .bottom-btns {
        padding: 110px 0 0;
        .btn1 {
          margin-left: 140px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/interview.vue